import { signCredential } from '@trustvc/w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const signW3C = /* @__PURE__ */ __name(async (credential, keyPair, cryptoSuite = "ecdsa-sd-2023", options) => {
  return signCredential(credential, keyPair, cryptoSuite, options);
}, "signW3C");

export { signW3C };
